import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

export const accountLedgerService = createApi({
  reducerPath: "accountLedgerService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["accountLedger"],
  endpoints: (builder) => ({
    getLedger: builder.mutation({
      query: (body) => ({
        url: `${userManagement.accountLedgerController.getLedger}`,
        method: "POST",
        headers: { Authorization: `Bearer ${body.token}` },
        body: body.payload,
      }),
    }),

    exportLedgerExcel: builder.mutation({
      query: (body) => ({
        url: `${userManagement.accountLedgerController.exportExcel}`,
        method: "POST",
        headers: { Authorization: `Bearer ${body.token}` },
        body: body.payload,
        responseHandler: async (response) => {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "Account_Ledger.xlsx";
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
          return { success: true };
        },
      }),
    }),
  }),
});

export const { useGetLedgerMutation ,useExportLedgerExcelMutation } = accountLedgerService;
